import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      navigate(user.role === "admin" || user.role === "finance" || user.role === "operations" ? "/admin" : "/portal");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0A4F35] p-12 text-white">
        <Logo variant="text" />
        <div>
          <h2 className="font-display text-4xl font-extrabold leading-tight">Your fuel supply,<br />under control.</h2>
          <p className="mt-4 text-emerald-100/80 max-w-md">
            Track orders, view quotations and settle balances — all from one secure corporate portal.
          </p>
        </div>
        <p className="text-xs text-emerald-100/50">RC: 1117437</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Customer Login</h1>
          <p className="mt-2 text-slate-500">Access your RODAIR portal.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" required />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full h-11 bg-[#0A4F35] hover:bg-[#083D29] text-white font-semibold">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-500">
            New customer? <Link to="/register" className="font-semibold text-[#0A4F35] hover:underline">Activate your portal</Link>
          </p>
          <p className="mt-2 text-sm text-slate-500">
            <Link to="/" className="hover:underline">← Back to website</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
